<template>
  <div class="login-page">
    <div class="container">
      <form
        v-if="response !== 200"
        class="login card mx-auto needs-validation"
        novalidate
        style="border-radius: 4px; box-shadow: unset;"
      >
        <validation-observer
          ref="form"
          v-slot="{ invalid }"
        >
          <div class="card-body">
            <div class="text-center">
              <a
                class="logo"
                href="#"
                @click.prevent.stop="$router.push('/entries')"
              >
                <MainLogo
                  width="126"
                  height="40"
                  style="margin-bottom: 32px;"
                />
              </a>
            </div>
            <base-alert />
            <div class="form-group">
              <validation-provider
                ref="password"
                v-slot="{ errors, touched, pristine, valid, invalid, validated }"
                name="password"
                :rules="`required${confirmTouched ? '|confirmed:confirmation' : ''}`"
              >
                <div class="d-flex align-items-center">
                  <input
                    v-model="newPassword1"
                    class="form-control password-input"
                    :class="{'is-invalid': (invalid && touched) || (pristine && validated && invalid)}"
                    name="password1"
                    placeholder="New password"
                    :type="`${showPassword ? 'text' : 'password'}`"
                  >
                  <base-icon
                    :icon="`pass-${showPassword ? 'off' : 'on'}`"
                    class="password-input-icon"
                    :class="{'hide': (invalid && validated)}"

                    @click="showPassword = !showPassword"
                  />
                </div>
                <div
                  v-for="(error, index) in errors"
                  :key="`password_errors_${index}`"
                >
                  <div
                    v-if="touched || (pristine && validated && invalid)"
                    class="invalid-feedback"
                  >
                    {{ error }}
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="form-group">
              <validation-provider
                ref="password_confirm"
                v-slot="{ errors, touched, pristine, valid, invalid, validated }"
                name="password confirm"
                rules="required"
                vid="confirmation"
              >
                <div class="d-flex align-items-center">
                  <input
                    v-model="newPassword2"
                    class="form-control password-input"
                    :class="{'is-invalid': (invalid && touched) || (pristine && validated && invalid)}"
                    :type="`${showPassword ? 'text' : 'password'}`"
                    name="password2"
                    placeholder="Confirm password"
                    @blur="confirmTouched = true"
                  >
                  <base-icon
                    :icon="`pass-${showPassword ? 'off' : 'on'}`"
                    class="password-input-icon"
                    :class="{'hide': (invalid && validated)}"

                    @click="showPassword = !showPassword"
                  />
                </div>
                <div
                  v-for="(error, index) in errors"
                  :key="`password_confirm_errors_${index}`"
                >
                  <div
                    v-if="touched || (pristine && validated && invalid)"
                    class="invalid-feedback"
                  >
                    {{ error }}
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="text-center" style="margin-top: 32px;">
              <!-- <div class="d-inline-block position-relative"> -->
              <base-button
                v-show="!pwChanged && !spinner"
                inverse
                block
                style="height: 44px; font-size: 14px; background-color: #333333; opacity: 1;"
                variant="primary"
                :disabled="invalid || !confirmTouched"
                @click.prevent.stop.native="handleSubmit"
                @mousedown="confirmTouched = true"
              >
                Reset Password
              </base-button>
              <!-- <div
                v-if="!confirmTouched"
                class="position-absolute"
                style="left: 0; right: 0; top: 0; bottom: 0"
              />
              </div> -->

              <b-spinner
                v-if="spinner"
                variant="primary"
              />
              <div class="text-center">
                <base-button
                  style="height: 44px; font-size: 14px; background-color: transparent; margin-top: 16px; border: transparent;"
                  @click="$router.push('/login')"
                >
                  Cancel
                </base-button>
              </div>
            </div>
          </div>
        </validation-observer>
      </form>
      <form
        v-else-if="response === 200"
        class="login card mx-auto needs-validation"
        novalidate
        style="border-radius: 4px; box-shadow: unset;"
      >
        <div class="card-body">
          <div
            class="text-center mb-3"
            style="display: flex;justify-content: space-evenly; height: 33px;"
          >
            <p
              class="successtitle"
              style="font-family: 'Tiempos'; font-size: 27px;"
            >
              Success!
            </p>
          </div>
          <div class="text-center">
            <base-icon
              icon="checked-circle-v2"
            />
            <base-text
              class="mt-4"
              style="font-family: 'SilkaLight'; font-size: 16px;"
            >
              Your password has been updated.
            </base-text>
          </div>
          <div class="text-center" style="margin-top: 32px;">
            <!-- <div class="d-inline-block position-relative"> -->
            <base-button
              inverse
              block
              style="height: 44px; font-size: 14px; background-color: #333333; opacity: 1;"
              variant="primary"
              @click="goLogin"
            >
              Return to Login
            </base-button>
            <b-spinner
              v-if="spinner"
              variant="primary"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';
import { userService } from '@/_services';
import BaseButton from '@/components/Base/BaseButton';

export default {
  components: {
    BaseButton,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      newPassword1: null,
      newPassword2: null,
      uid: this.$route.params.uid,
      showPassword: false,
      token: this.$route.params.token,
      response: 400,

      pwChanged: false,
      spinner: false,

      confirmTouched: false,
    };
  },
  mounted() {
    this.clear();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    handleSubmit() {
      console.log('Submitted new password');
      this.spinner = true;
      userService.passwordResetConfirm(this.uid, this.token, this.newPassword1, this.newPassword2)
        .then(((response) => {
          this.pwChanged = true;
          this.success(response.data.detail);
          this.response = response.status;
          if (response.data.redirect) {
            window.location.href = response.data.redirect;
          }
        })).catch((error) => {
          if (error && error.response && error.response.data) {
            // Format error to display on base-alert
            const errorsList = [];
            // eslint-disable-next-line
            for (const [key, values] of Object.entries(error.response.data)) {
              if (key === 'token') {
                errorsList.push('Invalid token');
              } else {
                // eslint-disable-next-line
                for (let i = 0; i < values.length; i++) {
                  errorsList.push(values[i]);
                }
              }
            }
            this.error(`- ${errorsList.join('\n- ')}`);
          } else {
            this.error('Failed to update password. Try again later');
          }
        }).finally(() => {
          this.spinner = false;
        });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    goLogin() {
      this.$router.push('/login');
    },
  },
  watch: {
    newPassword2(newVal) {
      if (newVal.length === this.newPassword1.length) {
        this.confirmTouched = true;
      }
    },
  },
};
</script>
<style lang="scss">
  .login{
    margin-top: 10%;
    width: 100%;
    max-width: 500px;
  }

  .invalid-feedback {
    display: flex;
  }
  .form-control{
    height: 44px !important;
    color: #1b1b1b;
  }

  .form-control:hover{
    height: 44px !important;
    border-color: #ababab;
  }

  .form-control::placeholder{
    color: #909090;
    opacity: 1;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #909090;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: #909090;
  }

  .password-input-icon {
    height: 14px !important;
    margin-left: -38px !important;
    color: #909090;
  }
  .hide {
    display: none !important;
  }
  .is-invalid {
    background-size: 16px !important;
    border-color: #da1e28
  }
  .invalid-feedback{
    color: #da1e28;
  }
  .card-body{
    padding-top: 40px;
    padding-left: 64px;
    padding-right: 64px;
    padding-bottom: 40px;
  }
</style>
<style lang="scss" scoped>
  .successtitle{
    font-family: 'Tiempos' !important;
    display: inline;
    font-style: normal;
    font-weight: 600;
    font-size: 29px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #333;
    word-break: break-all;
  }
</style>
